//--------------------------------------------------------------------------
// This is an automatically generated file!
// import of interfaces for EnkIWPServer
//--------------------------------------------------------------------------

import { doRequest } from "./do-request"

//--------------------------------------------------------------------------
// TYPE DECLARATIONS
//--------------------------------------------------------------------------

export type TEnkUserGroup = {
 groupId: number;
 description?: string;
 relatienr?: number;
}

export type TEnkUserInfo = {
 username?: string;
 emailaddress?: string;
 displayname?: string;
 profilePicture?: string;
 groups: TEnkUserGroup[];
 roles?: string;
}

export type TEnkLoginResult = {
 mfaNeededWithMethod?: TEnkMFAMethode;
 mfaSetupRequired: boolean;
 mfaSetupKinds: TEnkMFAMethode[];
 user?: TEnkUserInfo;
}

export type TEnkMFAMethode = "none" | "app" | "sms" | "email"

export type TEnkIWPUserKind = "Guest" | "Client" | "Supplier" | "SubContracter" | "Worker"

export type TEnkIWPUserProfile = {
 userId: number;
 username?: string;
 emailAddress?: string;
 status?: number;
 userGroupId?: number;
 fullName?: string;
 aboutMe?: string;
 userKind: TEnkIWPUserKind;
 mobileNumber?: string;
 phoneNumber?: string;
 profilePicture?: string;
}

export type TEnkIWPUserNotifications = {
 notifyNewsletter: boolean;
 notifyCalendarEvents: boolean;
 notifyDocuments: boolean;
}

export type TEnkIwpReportStatus = "active" | "notFound"

export type TEnkIwpReport = {
 name?: string;
 reportFile?: string;
 status: TEnkIwpReportStatus;
 description?: string;
}

export type TEnkIWPDocumentLocation = {
 location?: string;
 name?: string;
}

export type TEnkIWPDocument = {
 location?: string;
 id?: string;
 isSubDir: boolean;
 name?: string;
 docType?: string;
 size: number;
 lastChanged: string /*TDateTime*/;
}

export type TStream = {
  url: string
  size: number
}

export type TEnkDataQueryParamInfo = {
 paramNaam?: string;
 displayLabel?: string;
 paramType?: string;
 defaultWaarde?: string;
 verplicht: boolean;
 volgorde: number;
}

export type TEnkDataQueryInfo = {
 id: number;
 naam?: string;
 beschrijving?: string;
 params: TEnkDataQueryParamInfo[];
}

export type TEnkDataQueryRequest = {
 id: number;
 limit: number;
 offset: number;
 paramNames: string[];
 paramValues: string[];
 filterColumns: string[];
 filterValues: string[];
}

export type TEnkDataQueryColumn = {
 name?: string;
 dataType?: string;
}

export type TEnkDataQueryRow = {
 values: string[];
}

export type TEnkDataQueryResult = {
 columns: TEnkDataQueryColumn[];
 rows: TEnkDataQueryRow[];
 totalCount: number;
 limited: boolean;
}

export type TEnkPhotoInfo = {
 bijlageInhoudId?: string;
 omschrijving?: string;
 bijlageType?: string;
 grootte: number;
}

export type TEnkIWPMelding = {
 meldingnr: number;
 aanmaakDatum: string /*TDateTime*/;
 mutatieDatum: string /*TDateTime*/;
 recordstatus: number;
 statusLabel?: string;
 omschrijving?: string;
 melding?: string;
 meldingDoor?: string;
 meldingsoort?: string;
 meldingsoortLabel?: string;
 prioriteit: number;
 prioriteitLabel?: string;
 contractnr?: string;
 contractOmschrijving?: string;
 installatienr?: string;
 installatieOmschrijving?: string;
 relatienaam?: string;
 isGewijzigd: boolean;
 heeftTerugkoppeling: boolean;
 isIntern: boolean;
}

export type TEnkIWPMeldingSoortItem = {
 code?: string;
 omschrijving?: string;
}

export type TEnkIWPNieuweMelding = {
 omschrijving?: string;
 melding?: string;
 meldingsoort?: string;
 prioriteit: number;
 contractnr?: string;
 installatienr?: string;
}

export type TEnkIWPTerugkoppeling = {
 terugkoppelingId: number;
 meldingnr: number;
 tekst?: string;
 doorNaam?: string;
 bron?: string;
 klantMagReageren: boolean;
 aanmaakDatum: string /*TDateTime*/;
}

export type TEnkIWPNieuweTerugkoppeling = {
 meldingnr: number;
 tekst?: string;
 klantMagReageren: boolean;
}

export type TEnkIWPServiceContractItem = {
 contractnr?: string;
 omschrijving?: string;
}

export type TEnkIWPInstallatieItem = {
 installatienr?: string;
 contractnr?: string;
 omschrijving?: string;
}

export type TEnkIWPPlanBonStatus = "pbsOpenstaand" | "pbsAangevraagd" | "pbsBevestigd" | "pbsGeweigerd"

export type TEnkIWPPlanBonInfo = {
 opdrachtbonnr?: string;
 omschrijving?: string;
 status: TEnkIWPPlanBonStatus;
 statusTekst?: string;
 bevestigdOp?: string;
 tijdblok?: string;
 datum?: string;
}

export type TEnkIWPPlanOverview = {
 relatieNaam?: string;
 bonnen: TEnkIWPPlanBonInfo[];
 csrfToken?: string;
}

export type TEnkIWPAvailabilityRequest = {
 opdrachtbonnr?: string;
}

export type TEnkIWPTimeSlot = {
 datum: string /*TDate*/;
 tijdblokId: number;
 beginTijd?: string;
 eindTijd?: string;
 omschrijving?: string;
 beschikbaar: boolean;
}

export type TEnkIWPAvailabilityDay = {
 datum: string /*TDate*/;
 dagNaam?: string;
 slots: TEnkIWPTimeSlot[];
}

export type TEnkIWPAvailabilityResult = {
 opdrachtbonnr?: string;
 omschrijving?: string;
 dagen: TEnkIWPAvailabilityDay[];
}

export type TEnkIWPScheduleRequest = {
 opdrachtbonnr?: string;
 datum: string /*TDate*/;
 tijdblokId: number;
}

export type TEnkIWPScheduleResult = {
 success: boolean;
 melding?: string;
 bevestigingVereist: boolean;
}

export type TEnkIWPPendingRequest = {
 plantaakId: number;
 opdrachtbonnr?: string;
 omschrijving?: string;
 werkadres?: string;
 klantNaam?: string;
 aangevraagdOp: string /*TDateTime*/;
 datum: string /*TDate*/;
 tijdblok?: string;
 voorgesteldeMonteur?: string;
}

export type TEnkIWPConfirmRequest = {
 plantaakId: number;
}

export type TEnkIWPConfirmResult = {
 success: boolean;
 melding?: string;
}

export type TEnkIWPRejectRequest = {
 plantaakId: number;
 reden?: string;
}

export type TEnkIWPRejectResult = {
 success: boolean;
 melding?: string;
}

export type TEnkIWPPlanAvailabilityRequest = {
 opdrachtbonnr?: string;
 csrfToken?: string;
}

export type TEnkIWPPlanScheduleRequest = {
 opdrachtbonnr?: string;
 datum: string /*TDate*/;
 tijdblokId: number;
 csrfToken?: string;
}



//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerAuth
//--------------------------------------------------------------------------

export class EnkIWPServerAuth {

  static API_PATH = "api/v1/auth"

  static async login(emailaddress: string, password: string, rememberMe: boolean, mfaCode: string): Promise<TEnkLoginResult> {
    const url = this.API_PATH + `/login`
    return doRequest<TEnkLoginResult, {emailaddress: string; password: string; rememberMe: boolean; mfaCode: string}>("POST", url, {emailaddress,password,rememberMe,mfaCode})
  }

  static async silentLogin(groupId: number): Promise<TEnkLoginResult> {
    const url = this.API_PATH + `/silentLogin?groupId=${encodeURIComponent(groupId)}`
    return doRequest<TEnkLoginResult, string>("POST", url, undefined)
  }

  static async getMfaQRCode(emailaddress: string, password: string): Promise<string> {
    const url = this.API_PATH + `/getMfaQRCode`
    return doRequest<string, {emailaddress: string; password: string}>("POST", url, {emailaddress,password})
  }

  static async sendAuthCode(emailaddress: string, password: string, method: TEnkMFAMethode): Promise<void> {
    const url = this.API_PATH + `/sendAuthCode`
    return doRequest<void, {emailaddress: string; password: string; method: TEnkMFAMethode}>("POST", url, {emailaddress,password,method})
  }

  static async verifyMfaCode(emailaddress: string, password: string, rememberMe: boolean, method: TEnkMFAMethode, mfaCode: string): Promise<TEnkLoginResult> {
    const url = this.API_PATH + `/verifyMfaCode`
    return doRequest<TEnkLoginResult, {emailaddress: string; password: string; rememberMe: boolean; method: TEnkMFAMethode; mfaCode: string}>("POST", url, {emailaddress,password,rememberMe,method,mfaCode})
  }

  static async logout(): Promise<void> {
    const url = this.API_PATH + `/logout`
    return doRequest<void, undefined>("POST", url, undefined)
  }

  static async autoLogin(token: string): Promise<TEnkLoginResult> {
    const url = this.API_PATH + `/autologin`
    return doRequest<TEnkLoginResult, string>("POST", url, token)
  }

  static async sendPasswordResetMail(emailaddress: string, state: string): Promise<void> {
    const url = this.API_PATH + `/sendPasswordResetMail`
    return doRequest<void, {emailaddress: string; state: string}>("POST", url, {emailaddress,state})
  }

  static async passwordReset(newPassword: string, code: string): Promise<string> {
    const url = this.API_PATH + `/resetPassword`
    return doRequest<string, {newPassword: string; code: string}>("POST", url, {newPassword,code})
  }

  static async getWelcomePage(): Promise<string> {
    const url = this.API_PATH + `/welcomePage`
    return doRequest<string, undefined>("GET", url, undefined)
  }

  static async setUserGroup(aGroup: number): Promise<TEnkUserInfo> {
    const url = this.API_PATH + `/setUserGroup`
    return doRequest<TEnkUserInfo, {aGroup: number}>("POST", url, {aGroup})
  }

  static async getProfile(): Promise<TEnkIWPUserProfile> {
    const url = this.API_PATH + `/profile`
    return doRequest<TEnkIWPUserProfile, undefined>("GET", url, undefined)
  }

  static async saveProfile(aProfile: TEnkIWPUserProfile): Promise<void> {
    const url = this.API_PATH + `/profile`
    return doRequest<void, TEnkIWPUserProfile>("POST", url, aProfile)
  }

  static async getNotifications(): Promise<TEnkIWPUserNotifications> {
    const url = this.API_PATH + `/notifications`
    return doRequest<TEnkIWPUserNotifications, undefined>("GET", url, undefined)
  }

  static async saveNotifications(aNotifications: TEnkIWPUserNotifications): Promise<void> {
    const url = this.API_PATH + `/notifications`
    return doRequest<void, TEnkIWPUserNotifications>("POST", url, aNotifications)
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerReports
//--------------------------------------------------------------------------

export class EnkIWPServerReports {

  static API_PATH = "api/v1/reports"

  static async getList(groupId: number): Promise<TEnkIwpReport[]> {
    const url = this.API_PATH + `/list?groupId=${encodeURIComponent(groupId)}`
    return doRequest<TEnkIwpReport[], undefined>("GET", url, undefined)
  }

  static async buildReport(groupId: number, reportName: string, params: string[]): Promise<ArrayBuffer> {
    const url = this.API_PATH + `/build`
    return doRequest<ArrayBuffer, {groupId: number; reportName: string; params: string[]}>("POST", url, {groupId,reportName,params})
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerDocuments
//--------------------------------------------------------------------------

export class EnkIWPServerDocuments {

  static API_PATH = "api/v1/documents"

  static async getLocations(groupId: number): Promise<TEnkIWPDocumentLocation[]> {
    const url = this.API_PATH + `/getLocations`
    return doRequest<TEnkIWPDocumentLocation[], {groupId: number}>("POST", url, {groupId})
  }

  static async getDocuments(groupId: number, location: string): Promise<TEnkIWPDocument[]> {
    const url = this.API_PATH + `/getDocuments`
    return doRequest<TEnkIWPDocument[], {groupId: number; location: string}>("POST", url, {groupId,location})
  }

  static async getDocument(groupId: number, location: string, id: string): Promise<TStream> {
    const url = this.API_PATH + `/getDocument`
    return doRequest<TStream, {groupId: number; location: string; id: string}>("POST", url, {groupId,location,id})
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerDataQueries
//--------------------------------------------------------------------------

export class EnkIWPServerDataQueries {

  static API_PATH = "api/v1/dataqueries"

  static async getList(groupId: number): Promise<TEnkDataQueryInfo[]> {
    const url = this.API_PATH + `/list?groupId=${encodeURIComponent(groupId)}`
    return doRequest<TEnkDataQueryInfo[], undefined>("GET", url, undefined)
  }

  static async getData(request: TEnkDataQueryRequest): Promise<TEnkDataQueryResult> {
    const url = this.API_PATH + `/getData`
    return doRequest<TEnkDataQueryResult, TEnkDataQueryRequest>("POST", url, request)
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerPhotos
//--------------------------------------------------------------------------

export class EnkIWPServerPhotos {

  static API_PATH = "api/v1/photos"

  static async getList(table: string, keyValue: string): Promise<TEnkPhotoInfo[]> {
    const url = this.API_PATH + `/list?table=${encodeURIComponent(table)}&keyValue=${encodeURIComponent(keyValue)}`
    return doRequest<TEnkPhotoInfo[], undefined>("GET", url, undefined)
  }

  static async getImage(id: string): Promise<ArrayBuffer> {
    const url = this.API_PATH + `/image?id=${encodeURIComponent(id)}`
    return doRequest<ArrayBuffer, undefined>("GET", url, undefined)
  }

  static async downloadAll(table: string, keyValue: string): Promise<ArrayBuffer> {
    const url = this.API_PATH + `/downloadAll?table=${encodeURIComponent(table)}&keyValue=${encodeURIComponent(keyValue)}`
    return doRequest<ArrayBuffer, undefined>("GET", url, undefined)
  }

  static async uploadPhoto(table: string, keyValue: string, omschrijving: string, bijlageType: string, content: ArrayBuffer): Promise<TEnkPhotoInfo> {
    const url = this.API_PATH + `/upload`
    return doRequest<TEnkPhotoInfo, {table: string; keyValue: string; omschrijving: string; bijlageType: string; content: ArrayBuffer}>("POST", url, {table,keyValue,omschrijving,bijlageType,content})
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerMeldingen
//--------------------------------------------------------------------------

export class EnkIWPServerMeldingen {

  static API_PATH = "api/v1/meldingen"

  static async getList(groupId: number, status: number): Promise<TEnkIWPMelding[]> {
    const url = this.API_PATH + `/list?groupId=${encodeURIComponent(groupId)}&status=${encodeURIComponent(status)}`
    return doRequest<TEnkIWPMelding[], {groupId: number; status: number}>("GET", url, undefined)
  }

  static async getDetail(groupId: number, meldingnr: number): Promise<TEnkIWPMelding> {
    const url = this.API_PATH + `/detail?groupId=${encodeURIComponent(groupId)}&meldingnr=${encodeURIComponent(meldingnr)}`
    return doRequest<TEnkIWPMelding, {groupId: number; meldingnr: number}>("GET", url, undefined)
  }

  static async getSoorten(): Promise<TEnkIWPMeldingSoortItem[]> {
    const url = this.API_PATH + `/soorten`
    return doRequest<TEnkIWPMeldingSoortItem[], undefined>("GET", url, undefined)
  }

  static async createMelding(groupId: number, melding: TEnkIWPNieuweMelding): Promise<TEnkIWPMelding> {
    const url = this.API_PATH + `/create`
    return doRequest<TEnkIWPMelding, {groupId: number; melding: TEnkIWPNieuweMelding}>("POST", url, {groupId,melding})
  }

  static async getTerugkoppelingen(groupId: number, meldingnr: number): Promise<TEnkIWPTerugkoppeling[]> {
    const url = this.API_PATH + `/terugkoppelingen?groupId=${encodeURIComponent(groupId)}&meldingnr=${encodeURIComponent(meldingnr)}`
    return doRequest<TEnkIWPTerugkoppeling[], {groupId: number; meldingnr: number}>("GET", url, undefined)
  }

  static async createTerugkoppeling(groupId: number, terugkoppeling: TEnkIWPNieuweTerugkoppeling): Promise<TEnkIWPTerugkoppeling> {
    const url = this.API_PATH + `/terugkoppeling`
    return doRequest<TEnkIWPTerugkoppeling, {groupId: number; terugkoppeling: TEnkIWPNieuweTerugkoppeling}>("POST", url, {groupId,terugkoppeling})
  }

  static async getContracten(groupId: number): Promise<TEnkIWPServiceContractItem[]> {
    const url = this.API_PATH + `/contracten?groupId=${encodeURIComponent(groupId)}`
    return doRequest<TEnkIWPServiceContractItem[], number>("GET", url, undefined)
  }

  static async getInstallaties(groupId: number, contractnr: string): Promise<TEnkIWPInstallatieItem[]> {
    const url = this.API_PATH + `/installaties?groupId=${encodeURIComponent(groupId)}&contractnr=${encodeURIComponent(contractnr)}`
    return doRequest<TEnkIWPInstallatieItem[], {groupId: number; contractnr: string}>("GET", url, undefined)
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerPlanner
//--------------------------------------------------------------------------

export class EnkIWPServerPlanner {

  static API_PATH = "api/v1/planner"

  static async getOverview(): Promise<TEnkIWPPlanOverview> {
    const url = this.API_PATH + `/overview`
    return doRequest<TEnkIWPPlanOverview, undefined>("GET", url, undefined)
  }

  static async getAvailability(aRequest: TEnkIWPAvailabilityRequest): Promise<TEnkIWPAvailabilityResult> {
    const url = this.API_PATH + `/getAvailability`
    return doRequest<TEnkIWPAvailabilityResult, TEnkIWPAvailabilityRequest>("POST", url, aRequest)
  }

  static async schedule(aRequest: TEnkIWPScheduleRequest): Promise<TEnkIWPScheduleResult> {
    const url = this.API_PATH + `/schedule`
    return doRequest<TEnkIWPScheduleResult, TEnkIWPScheduleRequest>("POST", url, aRequest)
  }

  static async getPendingRequests(): Promise<TEnkIWPPendingRequest[]> {
    const url = this.API_PATH + `/pending`
    return doRequest<TEnkIWPPendingRequest[], undefined>("GET", url, undefined)
  }

  static async confirmRequest(aRequest: TEnkIWPConfirmRequest): Promise<TEnkIWPConfirmResult> {
    const url = this.API_PATH + `/confirm`
    return doRequest<TEnkIWPConfirmResult, TEnkIWPConfirmRequest>("POST", url, aRequest)
  }

  static async rejectRequest(aRequest: TEnkIWPRejectRequest): Promise<TEnkIWPRejectResult> {
    const url = this.API_PATH + `/reject`
    return doRequest<TEnkIWPRejectResult, TEnkIWPRejectRequest>("POST", url, aRequest)
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerPlanToken
//--------------------------------------------------------------------------

export class EnkIWPServerPlanToken {

  static API_PATH = "api/v1/plan"

  static async getOverview(token: string): Promise<TEnkIWPPlanOverview> {
    const url = this.API_PATH + `/overview?token=${encodeURIComponent(token)}`
    return doRequest<TEnkIWPPlanOverview, undefined>("GET", url, undefined)
  }

  static async getAvailability(token: string, aRequest: TEnkIWPPlanAvailabilityRequest): Promise<TEnkIWPAvailabilityResult> {
    const url = this.API_PATH + `/availability?token=${encodeURIComponent(token)}`
    return doRequest<TEnkIWPAvailabilityResult, TEnkIWPPlanAvailabilityRequest>("POST", url, aRequest)
  }

  static async schedule(token: string, aRequest: TEnkIWPPlanScheduleRequest): Promise<TEnkIWPScheduleResult> {
    const url = this.API_PATH + `/schedule?token=${encodeURIComponent(token)}`
    return doRequest<TEnkIWPScheduleResult, TEnkIWPPlanScheduleRequest>("POST", url, aRequest)
  }


}
